import React from 'react';
import { motion } from 'framer-motion';

const About = () => {
  const aboutItems = [
    {
      id: 'mision',
      title: 'Misión',
      subtitle: 'Soluciones Inteligentes',
      description: 'Ofrecer soluciones innovadoras de calidad, garantizando la seguridad, eficiencia y durabilidad en cada proyecto. Estableciendo relaciones sólidas con nuestros clientes como su socio de confianza.',
      icon: 'próximamente'
    },
    {
      id: 'vision',
      title: 'Visión',
      subtitle: 'Opción #1',
      description: 'Aspiramos a ser reconocidos como líderes en la industria de proyectos industriales en Perú y a nivel internacional. Destacándonos por nuestra excelencia técnica, innovación constante y compromiso con la calidad y la satisfacción de clientes.',
      icon: 'próximamente'
    },
    {
      id: 'valores',
      title: 'Valores',
      subtitle: 'Excelencia Total',
      description: 'En DavidCorp, te ayudamos a generar valor a nuestros clientes a través de soluciones personalizadas y estamos comprometidos a garantizar:',
      list: ['INNOVACIÓN', 'CALIDAD', 'EFICIENCIA', 'PRECISIÓN'],
      icon: 'próximamente'
    }
  ];

  return (
    <section 
      id="nosotros" 
      className="py-20 bg-gradient-to-b from-white to-gray-50"
    >
      <div className="container-standard px-4">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-2xl md:text-3xl font-bold text-primary-dark mb-4">Sobre Nosotros</h2>
          <div className="w-20 h-1 bg-primary-accent mx-auto"></div>
          <p className="mt-6 text-base text-gray-600 max-w-3xl mx-auto">
            DavidCorp S.R.L. es una empresa líder en Perú, especializada en diseño, ingeniería, construcción de obras civiles y soluciones integrales para el sector industrial.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {aboutItems.map((item, index) => (
            <motion.div
              key={item.id}
              className="bg-white rounded-2xl shadow-xl overflow-hidden border border-gray-100 card-elevated flex flex-col"
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
            >
              <div className="p-8 flex-grow">
                <div className="flex justify-center mb-6">
                  {item.icon === 'próximamente' ? (
                    <div className="w-20 h-20 bg-primary-accent bg-opacity-10 rounded-full flex items-center justify-center text-gray-400">
                      <span className="text-xs text-center px-2">Próximamente</span>
                    </div>
                  ) : (
                    <img
                      src={item.icon}
                      alt={item.title}
                      className="w-12 h-12 object-contain"
                    />
                  )}
                </div>

                <h3 className="text-xl font-bold text-center text-primary-700 mb-2">{item.title}</h3>
                <h4 className="text-base font-semibold text-center text-accent-600 mb-4">{item.subtitle}</h4>

                <p className="text-gray-600 mb-4 text-center">{item.description}</p>

                {item.list && (
                  <ul className="space-y-2 mt-4">
                    {item.list.map((value, idx) => (
                      <li
                        key={idx}
                        className="flex items-center text-gray-700 text-sm font-medium"
                      >
                        <span className="w-2 h-2 bg-primary-accent rounded-full mr-3"></span>
                        {value}
                      </li>
                    ))}
                  </ul>
                )}
              </div>

              <div className="bg-gradient-to-r from-primary-dark to-primary-accent h-1 w-full"></div>
            </motion.div>
          ))}
        </div>

        <div className="mt-16 bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
          <h2 className="text-heading font-bold text-primary-dark mb-6 text-center">Nuestra Historia</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div>
              <p className="text-gray-600 mb-4">
                Fundada en 2020, DavidCorp S.R.L. ha crecido para convertirse en una de las empresas de ingeniería e industrial más respetadas en Perú. Nuestro compromiso con la excelencia y la innovación nos ha permitido construir una reputación impecable en el sector.
              </p>
              <p className="text-gray-600 mb-4">
                A lo largo de los años, hemos completado más de 200 proyectos exitosos en diversos sectores, desde minería e infraestructura hasta manufactura y energía. Cada proyecto refuerza nuestro compromiso con la seguridad, la calidad y la satisfacción del cliente.
              </p>
              <p className="text-gray-600">
                Nuestro equipo de ingenieros, arquitectos y profesionales técnicos altamente calificados continúa expandiendo los límites de lo posible en cada proyecto que emprendemos.
              </p>
            </div>
            <div className="bg-gray-100 rounded-xl w-full h-64 flex items-center justify-center text-gray-500 overflow-hidden">
              <div className="text-center p-4">
                <div className="text-4xl mb-2">🚧</div>
                <p className="text-sm font-medium">Próximamente</p>
                <p className="text-xs opacity-75 mt-1">Imagen de la historia de la empresa</p>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 bg-gradient-to-r from-primary-dark to-primary-accent rounded-2xl shadow-xl p-8 text-white">
          <h2 className="text-heading font-bold mb-4 text-center">Certificaciones y Reconocimientos</h2>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-6 text-center">
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🏆</span>
              </div>
              <h3 className="font-semibold">ISO 9001</h3>
              <p className="text-sm opacity-80">Calidad</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🛡️</span>
              </div>
              <h3 className="font-semibold">ISO 45001</h3>
              <p className="text-sm opacity-80">Seguridad</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🌱</span>
              </div>
              <h3 className="font-semibold">ISO 14001</h3>
              <p className="text-sm opacity-80">Ambiental</p>
            </div>
            <div className="p-4">
              <div className="bg-white bg-opacity-20 rounded-full w-16 h-16 flex items-center justify-center mx-auto mb-3">
                <span className="text-2xl">🏗️</span>
              </div>
              <h3 className="font-semibold">Premio PEI</h3>
              <p className="text-sm opacity-80">Excelencia</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;